import templateUrl from './feature-main-page-template.html';

export const featureMainPageTemplateComponent = {
	templateUrl,

	bindings: {
		details: '<',
		subFeature: '<'
	},

	controller: class FeatureMainPageTemplateComponent {
		constructor($state, ApiService) {
			'ngInject';

			this.$state = $state;
			this.apiService = ApiService;
		}

		$onInit() {
			this.stateName = this.$state.current.name;
		}

		_getImage(detail) {
			const image = detail.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/feature-main-page-template/feature-main-page-template.component.js